<teleport to="body">
<div class="modal fade" id="view_advert_modal" tabindex="-1" aria-labelledby="view_advert_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">

      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs mb-0" id="view_advert_label">
          Job Advert
        </p>
        <div class="d-flex align-items-center gap-2 pe-2">
          <button type="button" class="modal-btn-close btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
      </div>

      <div class="modal-body p-3">
        <div v-if="!viewAdvertData || !viewAdvertData.id" class="text-center py-5 text-muted">
          <p class="text-xxs">No advert data available</p>
        </div>

        <div v-else-if="!editMode">
          <div class="mb-3 p-2 border rounded-3 bg-light">
            <button
              class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs w-100 d-flex justify-content-between align-items-center"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#view_advert_job_description_block"
              aria-expanded="false"
              aria-controls="view_advert_job_description_block"
            >
              <span class="text-force-white"><i class="bi bi-file-earmark-text me-1 text-force-white"></i> Job Description</span>
              <i class="bi bi-chevron-down ms-auto text-force-white"></i>
            </button>

            <div id="view_advert_job_description_block" class="collapse mt-2">
              <div v-if="!viewAdvertData.job_profile_title && !viewAdvertData.job_profile_description && (!viewAdvertData.job_profile_sections || viewAdvertData.job_profile_sections.length === 0)"
                   class="text-center text-muted py-2 text-xxs">
                No job description found for this job profile.
              </div>

              <div v-else class="border rounded-3 bg-white p-2 job-description-scroll">
                <p class="fw-bold text-xxs mb-1">{{ viewAdvertData.job_profile_title || 'Job Description' }}</p>
                <div v-if="viewAdvertData.job_profile_description" class="text-muted text-xxs mb-2" v-html="advertCleanHtml(viewAdvertData.job_profile_description)"></div>

                <div v-for="(section, idx) in (viewAdvertData.job_profile_sections || [])" :key="'view-jd-'+idx" class="mb-2 p-2 border rounded-3 bg-light">
                  <p class="fw-bold text-xxs mb-1">{{ (section && section.title) || ('Section ' + (idx + 1)) }}</p>

                  <div v-if="section && section.table && section.table.rows && section.table.rows.length > 0 && advertHasTableContent(section)" class="table-responsive mb-2">
                    <table class="table table-sm table-bordered align-middle mb-0">
                      <thead class="table-light">
                        <tr>
                          <th v-for="(hdr, hIdx) in (section.table.headers || [])" :key="'view-jd-h-'+hIdx" class="text-xxs fw-semibold">
                            {{ typeof hdr === 'object' ? hdr.label : hdr }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, rIdx) in (section.table.rows || [])" :key="'view-jd-r-'+rIdx">
                          <td v-for="(cell, cIdx) in row" :key="'view-jd-c-'+cIdx" class="text-xxs" v-html="advertCleanHtml(cell)"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div v-else-if="section && section.descriptions && section.descriptions.length > 0">
                    <div v-for="(desc, dIdx) in section.descriptions" :key="'view-jd-d-'+dIdx" class="text-xxs text-dark mb-1" v-html="advertCleanHtml(desc)"></div>
                  </div>

                  <p v-else class="text-muted text-xxs mb-0 fst-italic">No content available for this section.</p>
                </div>

                <p v-if="(viewAdvertData.job_profile_sections || []).length === 0" class="text-muted text-xxs mb-0 fst-italic">No sections marked to show on advert.</p>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-6">
              <p class="text-xxs text-muted mb-0"><strong>Reference Number:</strong></p>
              <p class="text-xs mb-2">{{ viewAdvertData.reference_number || '-' }}</p>
            </div>
            <div class="col-md-6">
              <p class="text-xxs text-muted mb-0"><strong>Vacancies:</strong></p>
              <p class="text-xs mb-2">{{ viewAdvertData.vacancies || '-' }}</p>
            </div>
            <div class="col-md-6">
              <p class="text-xxs text-muted mb-0"><strong>Published Date:</strong></p>
              <p class="text-xs mb-2">{{ viewAdvertData.published_date || '-' }}</p>
            </div>
            <div class="col-md-6">
              <p class="text-xxs text-muted mb-0"><strong>Closing Date:</strong></p>
              <p class="text-xs mb-2">{{ viewAdvertData.closing_date || '-' }}</p>
            </div>
          </div>

          <div v-if="viewAdvertData.display_blocks && viewAdvertData.display_blocks.length > 0">
            <div v-for="(block, bidx) in (viewAdvertData.display_blocks || []).filter(item => item && item.kind !== 'profile')" :key="(block && block.key) || bidx" class="mb-3 p-3 border rounded-3 bg-light">
              <div class="d-flex align-items-center mb-2">
                <span class="badge bg-green-gov-dark rounded-50 me-2 d-flex align-items-center justify-content-center circle-badge-28">
                  {{ block.title ? block.title.charAt(0) : 'A' }}
                </span>
                <h6 class="fw-bold mb-0 text-xs">{{ block.title }}</h6>
              </div>

              <div v-if="block && block.kind === 'details'" class="text-xxs text-dark" v-html="advertCleanHtml(block.data)"></div>

              <template v-else>
                <div v-if="block && block.data && block.data.table && block.data.table.rows && block.data.table.rows.length > 0 && advertHasTableContent(block.data)" class="table-responsive">
                  <table class="table table-sm table-bordered align-middle mb-0">
                    <thead class="table-light">
                      <tr>
                        <th v-for="(hdr, hIdx) in (block.data.table.headers || [])" :key="'vb-h-'+hIdx" class="text-xxs fw-semibold">
                          {{ typeof hdr === 'object' ? hdr.label : hdr }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, rIdx) in (block.data.table.rows || [])" :key="'vb-r-'+rIdx">
                        <td v-for="(cell, cIdx) in row" :key="'vb-c-'+cIdx" class="text-xxs" v-html="advertCleanHtml(cell)"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div v-else-if="block && block.data && block.data.descriptions && block.data.descriptions.length > 0">
                  <div v-for="(desc, dIdx) in block.data.descriptions" :key="'vb-d-'+dIdx" class="text-xxs text-dark mb-2" v-html="advertCleanHtml(desc)"></div>
                </div>

                <div v-else-if="block && block.data && block.data.content" class="text-xxs text-dark" v-html="advertCleanHtml(block.data.content)"></div>

                <div v-else class="text-dark text-xxs fst-italic">No content available for this section.</div>

                <div v-if="block && block.data && block.data.subsections && block.data.subsections.length" class="mt-3 ps-3 border-start">
                  <div v-for="(subsection, subIdx) in block.data.subsections" :key="'vb-sub-'+subIdx" class="mb-3 p-2 border rounded-3 bg-white">
                    <p class="fw-semibold text-xxs mb-1">{{ subsection.title || ('Sub-section ' + (subIdx + 1)) }}</p>

                    <div v-if="subsection.table && subsection.table.rows && subsection.table.rows.length > 0 && advertHasTableContent(subsection)" class="table-responsive">
                      <table class="table table-sm table-bordered align-middle mb-0">
                        <thead class="table-light">
                          <tr>
                            <th v-for="(hdr, hIdx) in (subsection.table.headers || [])" :key="'vb-sub-h-'+hIdx" class="text-xxs fw-semibold">
                              {{ typeof hdr === 'object' ? hdr.label : hdr }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, rIdx) in (subsection.table.rows || [])" :key="'vb-sub-r-'+rIdx">
                            <td v-for="(cell, cIdx) in row" :key="'vb-sub-c-'+cIdx" class="text-xxs" v-html="advertCleanHtml(cell)"></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-else-if="subsection.content" class="text-xxs text-dark" v-html="advertCleanHtml(subsection.content)"></div>

                    <div v-else class="text-muted text-xxs fst-italic">No content available for this sub-section.</div>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <div class="d-flex justify-content-end mt-4">
            <button
              v-if="viewAdvertData && viewAdvertData.id"
              type="button"
              class="btn btn-primary-dark btn-sm text-xxs rounded-small shadow-sm text-white px-3"
              @click="enterEditMode">
              Edit
            </button>
          </div>
        </div>

        <div v-else>
          <div class="mb-2 p-2 border rounded-3 bg-light">
            <button
              class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs w-100 d-flex justify-content-between align-items-center"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#edit_advert_job_description_block"
              aria-expanded="false"
              aria-controls="edit_advert_job_description_block"
            >
              <span class="text-force-white"><i class="bi bi-file-earmark-text me-1 text-force-white"></i> Job Description</span>
              <i class="bi bi-chevron-down ms-auto text-force-white"></i>
            </button>

            <div id="edit_advert_job_description_block" class="collapse mt-2">
              <div v-if="!editAdvertData.job_profile_title && !editAdvertData.job_profile_description && (!editAdvertData.job_profile_sections || editAdvertData.job_profile_sections.length === 0)"
                   class="text-center text-muted py-2 text-xxs">
                No job description found for this job profile.
              </div>

              <div v-else class="border rounded-3 bg-white p-2 job-description-scroll">
                <p class="fw-bold text-xxs mb-1">{{ editAdvertData.job_profile_title || 'Job Description' }}</p>
                <div v-if="editAdvertData.job_profile_description" class="text-muted text-xxs mb-2 rich-content-view" v-html="advertCleanHtml(editAdvertData.job_profile_description)"></div>

                <div v-for="(section, idx) in (editAdvertData.job_profile_sections || [])" :key="'edit-jd-'+idx" class="mb-2 p-2 border rounded-3 bg-light">
                  <p class="fw-bold text-xxs mb-1">{{ section.title || ('Section ' + (idx + 1)) }}</p>

                  <div v-if="section.table && section.table.rows && section.table.rows.length > 0 && advertHasTableContent(section)" class="table-responsive mb-2">
                    <table class="table table-sm table-bordered align-middle mb-0">
                      <thead class="table-light">
                        <tr>
                          <th v-for="(hdr, hIdx) in section.table.headers" :key="'edit-jd-h-'+hIdx" class="text-xxs fw-semibold">
                            {{ typeof hdr === 'object' ? hdr.label : hdr }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, rIdx) in section.table.rows" :key="'edit-jd-r-'+rIdx">
                          <td v-for="(cell, cIdx) in row" :key="'edit-jd-c-'+cIdx" class="text-xxs" v-html="advertCleanHtml(cell)"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div v-else-if="section.descriptions && section.descriptions.length > 0">
                    <div v-for="(desc, dIdx) in section.descriptions" :key="'edit-jd-d-'+dIdx" class="text-xxs text-dark mb-1 rich-content-view" v-html="advertCleanHtml(desc)"></div>
                  </div>

                  <p v-else class="text-muted text-xxs mb-0 fst-italic">No content available for this section.</p>
                </div>

                <p v-if="(editAdvertData.job_profile_sections || []).length === 0" class="text-muted text-xxs mb-0 fst-italic">No sections marked to show on advert.</p>
              </div>
            </div>
          </div>

          <div class="mb-3 p-3 border rounded-3 bg-light">
            <p class="fw-bold text-xs mb-2"><i class="bi bi-card-heading me-1"></i> Advert Details</p>

            <div class="row g-2">
              <div class="col-md-6">
                <label class="form-label text-xxs fw-bold mb-1">Advert Title</label>
                <input
                  v-model="editAdvertData.title"
                  class="form-control form-control-sm text-xxs rounded-small shadow-sm"
                  type="text"
                  placeholder="Enter advert title"
                />
              </div>
            </div>

            <div class="row g-2 mt-1">
              <div class="col-md-6">
                <label class="form-label text-xxs fw-bold mb-1">Reference Number</label>
                <input
                  v-model="editAdvertData.reference_number"
                  class="form-control form-control-sm text-xxs rounded-small shadow-sm"
                  type="text"
                  placeholder="e.g. REF-2025-001"
                />
              </div>
            </div>

            <div class="row g-2">
              <div class="col-md-3">
                <label class="form-label text-xxs fw-bold mb-1">Opening Date &amp; Time</label>
                <input
                  v-model="editAdvertData.published_date"
                  class="form-control form-control-sm text-xxs rounded-small shadow-sm"
                  type="datetime-local"
                  :min="editAdvertMinimumDateTime"
                />
              </div>
              <div class="col-md-3">
                <label class="form-label text-xxs fw-bold mb-1">Closing Date &amp; Time</label>
                <input
                  v-model="editAdvertData.closing_date"
                  class="form-control form-control-sm text-xxs rounded-small shadow-sm"
                  type="datetime-local"
                  :min="editAdvertClosingMinimumDateTime"
                />
              </div>
            </div>

            <div class="row g-2 mt-1">
              <div class="col-md-6">
                <label class="form-label text-xxs fw-bold mb-1">Vacancies</label>
                <input
                  v-model.number="editAdvertData.vacancies"
                  class="form-control form-control-sm text-xxs rounded-small shadow-sm"
                  type="number"
                  min="0"
                  placeholder="Number of vacancies"
                />
              </div>
            </div>

            <div class="row g-2 mt-1">
              <div class="col-md-6">
                <label class="form-label text-xxs fw-bold mb-1">Additional Details</label>
                <textarea
                  v-model="editAdvertData.details"
                  dir="ltr"
                  class="form-control form-control-sm text-xxs rounded-small shadow-sm rich-text-input"
                  @input="rebuildEditDisplayOrder"
                  rows="2"
                  placeholder="Any additional details for the advert..."
                ></textarea>
              </div>
            </div>
          </div>

          <div class="mb-3 p-3 border rounded-3 bg-light">
            <p class="fw-bold text-xs mb-2">Display Order</p>
            <small class="text-muted text-xxs d-block mb-2">Drag items using the grip on the right to set how users will see the advert.</small>
            <div v-if="editAdvertData.display_order && editAdvertData.display_order.length > 0">
              <div
                v-for="(item, idx) in editAdvertData.display_order"
                :key="item.key"
                class="d-flex justify-content-between align-items-center border rounded-3 p-2 mb-2 bg-white"
                draggable="true"
                @dragstart="onDisplayDragStart(idx)"
                @dragover.prevent
                @drop="onDisplayDrop(idx)"
                @dragend="onDisplayDragEnd"
              >
                <div>
                  <p class="mb-0 text-xxs fw-bold">
                    {{ item.source === 'details' ? 'Additional Information' :
                      (editAdvertData.sections[item.index]?.title || ('Advert Section ' + (item.index + 1))) }}
                  </p>
                  <small class="text-muted text-xxs">
                    {{ item.source === 'details' ? 'Advert Details' : 'Advert Section' }}
                  </small>
                </div>
                <div class="d-flex align-items-center">
                  <span class="border rounded-small px-2 py-1 text-muted" title="Drag to reorder">
                    <i class="bi bi-grip-vertical"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3 p-3 border rounded-3 bg-light">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <p class="fw-bold text-xs mb-0">Advertisement Sections</p>
              <button class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs" @click="addAdvertSection">
                Add Section
              </button>
            </div>

            <div v-if="!editAdvertData.sections || editAdvertData.sections.length === 0" class="text-center py-3 text-muted">
              <p class="text-xxs">No sections added yet. Click "Add Section" to create one.</p>
            </div>

            <div v-for="(section, sidx) in (editAdvertData.sections || [])" :key="sidx" class="mb-3 p-2 border rounded-3 bg-white">
              <div class="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                <h6 class="fw-bold text-xxs mb-0">Section {{ sidx + 1 }}</h6>
                <div class="d-flex gap-1">
                  <button class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs" @click="removeAdvertSection(sidx)">
                    Remove
                  </button>
                </div>
              </div>

              <div class="row g-2">
                <div class="col-md-6">
                  <label class="form-label text-xxs fw-bold mb-1">Section Title</label>
                  <input
                    v-model="section.title"
                    class="form-control form-control-sm text-xxs rounded-small shadow-sm"
                    type="text"
                    placeholder="e.g. Benefits, Requirements"
                  />
                </div>

                <div class="col-md-6">
                  <label class="form-label text-xxs fw-bold mb-1">Content Type</label>
                  <select v-model="section.type" class="form-select form-select-sm text-xxs rounded-small shadow-sm">
                    <option value="text">Text</option>
                    <option value="table">Table</option>
                  </select>
                </div>
              </div>

              <div v-if="section.type === 'text'" class="row g-2 mt-1">
                <div class="col-12">
                  <label class="form-label text-xxs fw-bold mb-1">Content</label>
                  <div class="d-flex flex-wrap gap-1 mb-2">
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('bold')"><i class="bi bi-type-bold text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('italic')"><i class="bi bi-type-italic text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('underline')"><i class="bi bi-type-underline text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('insertUnorderedList')"><i class="bi bi-list-ul text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('justifyLeft')"><i class="bi bi-text-left text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('justifyCenter')"><i class="bi bi-text-center text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('justifyRight')"><i class="bi bi-text-right text-force-white"></i></button>
                  </div>
                  <div
                    class="form-control form-control-sm text-xxs rounded-small shadow-sm rich-editor-content"
                    contenteditable="true"
                    dir="ltr"
                    @focus="setActiveRichEditor($event)"
                    @blur="section.content = $event.target.innerHTML"
                    v-html="section.content || ''"
                  ></div>
                </div>
              </div>

              <div v-else-if="section.type === 'table'" class="row g-2 mt-2">
                <div class="col-12">
                  <label class="form-label text-xxs fw-bold mb-1">Table Headers</label>
                  <div class="d-flex gap-2 mb-2">
                    <input v-for="(hdr, hidx) in (section.table && section.table.headers || [])" :key="'h-'+hidx"
                           v-model="section.table.headers[hidx]"
                           type="text"
                           class="form-control form-control-sm text-xxs rounded-small shadow-sm"
                           placeholder="Header name"
                    />
                    <button class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs" @click="section.table.headers.push('')">+</button>
                  </div>
                </div>

                <div class="col-12">
                  <label class="form-label text-xxs fw-bold mb-1">Table Rows</label>
                  <div class="d-flex flex-wrap gap-1 mb-2">
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('bold')"><i class="bi bi-type-bold text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('italic')"><i class="bi bi-type-italic text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('underline')"><i class="bi bi-type-underline text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('insertUnorderedList')"><i class="bi bi-list-ul text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('justifyLeft')"><i class="bi bi-text-left text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('justifyCenter')"><i class="bi bi-text-center text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('justifyRight')"><i class="bi bi-text-right text-force-white"></i></button>
                  </div>
                  <div v-for="(row, ridx) in (section.table && section.table.rows || [])" :key="'r-'+ridx" class="d-flex gap-2 mb-2">
                    <div
                      v-for="(cell, cidx) in row"
                      :key="'c-'+cidx"
                      class="form-control form-control-sm text-xxs rounded-small shadow-sm flex-grow-1 rich-editor-cell"
                      contenteditable="true"
                      dir="ltr"
                      @focus="setActiveRichEditor($event)"
                      @blur="section.table.rows[ridx][cidx] = $event.target.innerHTML"
                      v-html="section.table.rows[ridx][cidx] || ''"
                    ></div>
                    <button class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs" @click="section.table.rows.splice(ridx, 1)">Delete</button>
                  </div>
                  <button class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs w-100 mt-2"
                          @click="section.table.rows.push(new Array(section.table.headers.length || 1).fill(''))">
                    Add Row
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-end gap-2 mt-4">
            <button
              type="button"
              class="btn btn-primary-dark btn-sm text-xxs rounded-small shadow-sm text-white px-3"
              @click="exitEditMode">
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary-dark btn-sm text-xxs rounded-small shadow-sm text-white px-3"
              :disabled="advertSaving"
              @click="saveAdvertChanges">
              {{ advertSaving ? 'Saving...' : 'Save Changes' }}
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
</teleport>
